import get from 'lodash/get';

import {
  ArticleContent,
  FormattedArticleContent,
  FormattedFragment
} from '../types';
import { getLinkHref } from 'shared/helpers/uri';
import formatFragments from './formatFragments';

export default function formatArticleContent({
  articleContent,
  domainUrl,
  zone
}: {
  articleContent: ArticleContent;
  domainUrl: string;
  zone: string;
}): FormattedArticleContent {
  return {
    id: get(articleContent, 'articleId', null),
    title: get(articleContent, 'title', null),
    subtitle: get(articleContent, 'subtitle', null),
    link: get(articleContent, 'link', null),
    slug: get(articleContent, 'slug', ''),
    mainMedia: getLinkHref(get(articleContent, 'mainMedia.link', '')),
    responsiveMedia: getLinkHref(
      get(articleContent, 'responsiveMedia.link', '')
    ),
    fragments: articleContent.fragments
      .map(item =>
        formatFragments({
          fragment: item,
          domainUrl,
          zone
        })
      )
      .filter(Boolean) as FormattedFragment[]
  };
}
